import React from "react";
import { useState } from "react";
import { href } from "react-router-dom";
import { motion, Variants } from "framer-motion";

type MarketingMediaViewProps = {
  imageUrls: string[];
  titles?: string[];
  scrollRef: React.RefObject<HTMLDivElement | null>;
  hrefs: string[];
};

const MarketingMediaView = ({
  imageUrls,
  titles,
  scrollRef,
  hrefs,
}: MarketingMediaViewProps) => {
  const [openVideo, setOpenVideo] = useState<string | null>(null);
  const timelineVariants: Variants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100, damping: 15 },
    },
  };


  return (
    <>
      <div
        ref={scrollRef}
        className="marketing-media-view max-w-6xl mx-auto px-4"
      >
        <div className="grid grid-cols-2 grid-rows-2 gap-8">
          {imageUrls.map((url, index) => (

              <div
                key={index}
                className="flex flex-col justify-center items-center"
              >
                <motion.div
                  key={index}
                  variants={timelineVariants}
                  whileHover={{ scale: 1.05 }}
                  onClick={() => setOpenVideo(hrefs[index])}
                  className="cursor-pointer snap-start shadow-xl flex-shrink-0 w-[160px] tablet:w-80 laptop:w-[476px] desktop:w-[500px] h-[260px] rounded-3xl object-cover"
                  style={{
                    backgroundImage: `url(${url})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                </motion.div>
                <p className="font-sans font-bold text-xl text-[#f82836] pt-3">
                  {titles ? titles[index] : ""}
                </p>
              </div>
          ))}
        </div>
      </div>

      {openVideo && (
        <div
          onClick={() => setOpenVideo(null)}
          className="fixed inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center"
        >
          <div className="relative w-[90vw] max-w-3xl aspect-video bg-black rounded-lg overflow-hidden">
            <iframe
              src={openVideo}
              title="영상 플레이어"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default MarketingMediaView;
